<ng-template #approveModal>
	<mat-horizontal-stepper [selectedIndex]="currentStepIndex" #stepper>
		<mat-step label="Select Groups" editable="true">
			<div class="step">
				<map-group-tree
						*ngIf="dialogData"
						[dataset]="dialogData.dataset"
						(treeChanged)="selectGroup($event)"
				></map-group-tree>
				<div class="step-controls">
					<button mat-flat-button color="primary" class="cancel-btn" (click)="onNoClick()">Cancel</button>
					<button color="accent" mat-flat-button class="cancel-btn" matStepperNext [disabled]="!selectedGroupID"> Next
					</button>
				</div>
			</div>
		</mat-step>
		<mat-step label="Select Used Fields" editable="true" [stepControl]="fieldsFormGroup">
			<div class="step">
				<h6 style="margin: 8px 0;">Fields:</h6>
				<form
						*ngIf="fieldsFormGroup"
						style="display:flex; flex-direction:column; margin-bottom:25px;height: 350px;
						overflow: auto;"
						[formGroup]="fieldsFormGroup"
				>
					<mat-checkbox
							*ngFor="let field of fields"
							[formControlName]="field.id"
					>{{ field.name }}</mat-checkbox
					>
				</form>
				<div class="step-controls">
					<button matStepperPrevious mat-flat-button color="primary" class="cancel-btn">Back</button>
					<button color="accent" mat-flat-button class="cancel-btn" matStepperNext [disabled]="!selectedGroupID"> Next
					</button>
				</div>
			</div>
		</mat-step>
		<mat-step label="Done" editable="true">
			<div class="step-final step">
				<h5 *ngIf="!isLoading" class="submit" style="margin: 8px 0;">Submit drafts for approval ?</h5>
				<mat-spinner *ngIf="isLoading" diameter="40" color="accent"></mat-spinner>
			</div>
			<div class="step-controls">
				<button matStepperPrevious mat-flat-button color="primary">Back</button>

				<button [disabled]="isLoading" color="accent" mat-flat-button (click)="submitDraftsForApproval()">
					Submit
				</button>
			</div>
		</mat-step>
	</mat-horizontal-stepper>
	<mat-progress-bar color="accent" mode="indeterminate" class="loading-bar" *ngIf="isLoading"></mat-progress-bar>

</ng-template>
